import { render, staticRenderFns } from "./page-detail-deliver.vue?vue&type=template&id=4a3d9679&scoped=true&"
import script from "./page-detail-deliver.vue?vue&type=script&lang=js&"
export * from "./page-detail-deliver.vue?vue&type=script&lang=js&"
import style0 from "./page-detail-deliver.vue?vue&type=style&index=0&id=4a3d9679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d9679",
  null
  
)

export default component.exports